const features = [
  {
    title: '海量片库',
    desc: '片多多影视拥有超过20000部高清影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类，从经典老片到最新大片一应俱全。片多多免费观看，找片不发愁。',
    icon: 'ri-database-2-line',
  },
  {
    title: '超清画质',
    desc: '支持1080P至4K超清画质在线播放，采用先进编码技术，在保证清晰度的同时最小化带宽消耗。片多多高清免费，每一帧都清晰动人。',
    icon: 'ri-4k-line',
  },
  {
    title: '流畅不卡',
    desc: '片多多影视采用全球CDN加速节点和智能缓冲技术，确保片多多高清不卡。无论您使用什么网络环境，都能获得丝滑流畅的在线观影体验。',
    icon: 'ri-speed-up-line',
  },
  {
    title: '每日更新',
    desc: '专业内容团队全天候运作，热门影视上线即同步。新剧新片第一时间更新到片多多影视平台，让您追剧快人一步，精彩不容错过。',
    icon: 'ri-refresh-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台优势</h2>
            <p className="mt-3 text-sm text-foreground-500">为什么选择片多多影视</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((f, i) => (
              <div key={i} className="bg-background-100 rounded-2xl p-6 md:p-7 text-center group hover:-translate-y-1 transition-all duration-300 cursor-pointer">
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5 ${
                  i % 2 === 0 ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                }`}>
                  <i className={`${f.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900">{f.title}</h3>
                <p className="mt-3 text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}